import { render, staticRenderFns } from "./PrincipalCausa.vue?vue&type=template&id=271fb012&"
import script from "./PrincipalCausa.vue?vue&type=script&lang=js&"
export * from "./PrincipalCausa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports